import * as React from 'react';
import * as classNames from 'classnames/bind';

import LogoRow from '../../containers/LogoRow/LogoRow';

import styles from './Header.scss';

const cx = classNames.bind(styles);

interface HeaderProps {
  backgroundImage?: string;
  backgroundSize?: React.CSSProperties['backgroundSize'];
  backgroundPosition?: React.CSSProperties['backgroundPosition'];
  title: string;
  subtitle?: string;
  small?: boolean;
}

const Header: React.SFC<HeaderProps> = ({
  backgroundImage,
  backgroundSize,
  backgroundPosition,
  title,
  subtitle,
  small,
  children,
}) => (
  <header
    className={cx({
      small,
      header: true,
    })}
    style={{
      backgroundPosition,
      backgroundSize,
      backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
    }}
  >
    <div className="container d-flex flex-column align-items-center">
      <LogoRow />
      <div className={styles.headerContent}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {children}
    </div>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// /www/client/src/components/Header/Header.tsx